import { useContext } from "react";
import { MdArrowOutward } from "react-icons/md";
import { AppContext } from "../App";
import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import buildingImage from "../assets/building construction (1).jpg";
import civilImage from "../assets/civil engineering (1).jpg";
import designImage from "../assets/construction design (1).jpg";
import roadImage from "../assets/road construction.jpg";
import construction1 from "../assets/construction1.png";
import construction2 from "../assets/construction2.png";
import construction3 from "../assets/construction3.png";
import kigamboni from "../assets/kigamboni.jpeg";
import kigamboni1 from "../assets/kigamboni1.jpeg";
import kigamboni2 from "../assets/kigamboni2.jpeg";
import kigamboni3 from "../assets/kigamboni3.jpeg";
import kg1 from "../assets/kg1.jpeg";
import kg2 from "../assets/kg2.jpeg";
import kg3 from "../assets/kg3.jpeg";
import max1 from "../assets/max1.jpeg";
import max2 from "../assets/max2.jpeg";
import max3 from "../assets/max3.jpeg";
import moro1 from "../assets/moro1.jpeg";
import moro2 from "../assets/moro2.jpeg";
import moro3 from "../assets/moro3.jpeg";
import songea1 from "../assets/songea1.png";
import songea2 from "../assets/songea2.png";
import songea3 from "../assets/songea3.png";
import tazara from "../assets/tazara.jpeg";
import tazara1 from "../assets/tazara1.jpeg";
import tazara2 from "../assets/tazara2.jpeg";
import tazara3 from "../assets/tazara3.jpeg";
import dodoma1 from "../assets/dodoma1.jpeg";
import dodoma2 from "../assets/dodoma2.jpeg";
import dodoma3 from "../assets/dodoma3.jpeg";
import kipawa from "../assets/kipawa.jpeg";
import kipawa1 from "../assets/kipawa1.jpeg";
import kipawa2 from "../assets/kipawa2.jpeg"
import kipawa3 from "../assets/kipawa3.jpeg"

export const projects = [
  {
    slug: "mbweni-residential-design-build",
    name: "Mbweni Residential Design & Build",
    status: "Ongoing project",
    role: "Main Contractor",
    client: "Nadia Mwita",
    value: "Tshs 258,400,000",
    location: "Mbweni, Dar es Salaam",
    category: "Building Work",
    description:
      "Design and build residential building project at Mbweni, Dar es Salaam, listed in the SNJ Tanzania Limited company profile as an ongoing building work.",
    image: kipawa,
    images: [kipawa1, kipawa2, kipawa3],
  },
  {
    slug: "nanyamba-water-infrastructure",
    name: "Nanyamba Water Infrastructure Rehabilitation",
    status: "Profile listed",
    role: "SNJ JV JUIN",
    client: "MTUWASA",
    value: "Tshs 4,278,810,500",
    location: "Nanyamba, Mtwara",
    category: "Water Project",
    description:
      "Rehabilitation of water infrastructure in Nanyamba, Mtwara, recorded in the company profile under SNJ JV JUIN water project experience.",
    image: tazara,
    images: [tazara1, tazara2, tazara3],
  },
  {
    slug: "kwimba-district-court-building",
    name: "Kwimba District Court Building",
    status: "Profile listed",
    role: "Main Contractor",
    client: "Judiciary of Tanzania",
    value: "Tshs 1,098,314,645",
    location: "Kwimba, Mwanza Region",
    category: "Building Works",
    description:
      "Proposed construction of a district court building at Kwimba in Mwanza Region for the Judiciary of Tanzania.",
    image: buildingImage,
    images: [buildingImage, construction1, construction2],
  },
  {
    slug: "rubya-plantation-office-block",
    name: "Rubya Plantation Office Block",
    status: "Profile listed",
    role: "Main Contractor",
    client: "Rubya Forest",
    value: "Tshs 271,971,034.77",
    location: "Ukerewe District, Mwanza Region",
    category: "Building Works",
    description:
      "Proposed construction of an office block at Rubya Plantation in Ukerewe District, Mwanza Region.",
    image: construction1,
    images: [construction1, construction2, construction3],
  },
  {
    slug: "buhindi-plantation-office-block",
    name: "Buhindi Plantation Office Block",
    status: "Profile listed",
    role: "Main Contractor",
    client: "Buhindi Forest",
    value: "Tshs 260,073,537",
    location: "Sengerema District, Mwanza Region",
    category: "Building Works",
    description:
      "Proposed construction of an office block at Buhindi Plantation in Sengerema District, Mwanza Region.",
    image: designImage,
    images: [designImage, kg1, kg2],
  },
  {
    slug: "tfs-simanjiro-office-building",
    name: "TFS Simanjiro Office Building",
    status: "Profile listed",
    role: "Main Contractor",
    client: "TFS Central Zone",
    value: "Tshs 247,975,500",
    location: "Simanjiro",
    category: "Building Works",
    description:
      "Construction of TFS Simanjiro office building for the Tanzania Forest Services Central Zone.",
    image: dodoma1,
    images: [dodoma1, dodoma2, dodoma3],
  },
  {
    slug: "tfs-bahi-office-building",
    name: "TFS Bahi Office Building",
    status: "Profile listed",
    role: "Main Contractor",
    client: "TFS Central Zone",
    value: "Tshs 247,878,000",
    location: "Bahi",
    category: "Building Works",
    description:
      "Construction of TFS Bahi office building for the Tanzania Forest Services Central Zone.",
    image: max1,
    images: [max1, max2, max3],
  },
  {
    slug: "nyankarata-ranger-post",
    name: "Nyankarata Ranger Post",
    status: "Profile listed",
    role: "Main Contractor",
    client: "TFS Lake Zone",
    value: "Tshs 158,337,000",
    location: "Nyankarata Forest Reserves",
    category: "Building Works",
    description:
      "Construction of one ranger post at Nyankarata Forest Reserves for Tanzania Forest Services Lake Zone.",
    image: kg1,
    images: [kg1, kg2, kg3],
  },
  {
    slug: "tarura-mara-road-improvement",
    name: "TARURA Mara Road Improvement",
    status: "Profile listed",
    role: "Main Contractor",
    client: "TARURA Mara",
    value: "Tshs 344,324,811.47",
    location: "Mara Region",
    category: "Civil Works",
    description:
      "Routine maintenance of 14.64km and spot improvement of 25.03km, listed in the SNJ Tanzania Limited profile for TARURA Mara.",
    image: roadImage,
    images: [roadImage, moro1, moro2],
  },
  {
    slug: "korogwe-drift-box-culvert",
    name: "Korogwe Drift & Box Culvert Works",
    status: "2022-2023",
    role: "Main Contractor",
    client: "TARURA Korogwe",
    value: "Tshs 236,700,000",
    location: "Korogwe District",
    category: "Civil Work",
    description:
      "Routine maintenance and construction of drift and box culvert along various roads in Korogwe District.",
    image: moro1,
    images: [moro1, moro2, moro3],
  },
  {
    slug: "tandahimba-road-improvement",
    name: "Tandahimba Road Improvement Works",
    status: "2022-2023",
    role: "Main Contractor",
    client: "TARURA Tandahimba",
    value: "Tshs 206,000,000",
    location: "Tandahimba District",
    category: "Civil Works",
    description:
      "Routine and spot improvement of various roads in Tandahimba District for TARURA Tandahimba.",
    image: tazara1,
    images: [tazara1, tazara2, tazara3],
  },
  {
    slug: "dart-passenger-sheds-ticket-booths",
    name: "Passenger Sheds & Ticket Booths",
    status: "2020",
    role: "Main Contractor",
    client: "Dar Rapid Transit (DART)",
    value: "Tshs 191,963,355.80",
    location: "Dar es Salaam",
    category: "Civil and Building Works",
    description:
      "Construction of passenger sheds at Muhimbili and Mbezi feeder stations, plus supply and fixing of ticket booths along the Kimara-Mbezi feeder route.",
    image: tazara,
    images: [tazara, tazara1, tazara2, tazara3],
  },
  {
    slug: "goba-residential-building",
    name: "Goba Residential Building",
    status: "2020-2021",
    role: "Main Contractor",
    client: "Joffrey Mwalega",
    value: "Tshs 120,873,000",
    location: "Goba, Ubungo Municipality",
    category: "Building Works",
    description:
      "Construction of a residential building at Goba in Ubungo Municipality, delivered as a building works project.",
    image: kigamboni,
    images: [kigamboni, kigamboni1, kigamboni2],
  },
  {
    slug: "geza-kigamboni-residential-renovation",
    name: "Geza Kigamboni Residential Renovation",
    status: "2020-2021",
    role: "Main Contractor",
    client: "Arkie Mwalega",
    value: "Tshs 58,335,000",
    location: "Geza, Kigamboni",
    category: "Building Works",
    description:
      "Renovation of an existing residential building at Geza, Kigamboni.",
    image: kigamboni1,
    images: [kigamboni1, kigamboni2, kigamboni3],
  },
  {
    slug: "fence-electric-security-landscaping",
    name: "Fence, Electric Security & Landscaping",
    status: "2023",
    role: "Main Contractor",
    client: "Joffrey Mwalega",
    value: "Tshs 37,500,400",
    location: "Tanzania",
    category: "Building Works",
    description:
      "Construction of fence, installation of an electric fence security system, and landscaping works.",
    image: construction3,
    images: [construction3, designImage, buildingImage],
  },
  {
    slug: "ikiliminzowo-water-supply-sanitation",
    name: "Ikiliminzowo Water Supply & Sanitation",
    status: "2014-2016",
    role: "Sub-Contractor",
    client: "Mufindi District Council",
    value: "Tshs 831,000,000",
    location: "Mufindi District",
    category: "Civil-Water Project",
    description:
      "Construction of the Ikiliminzowo pumping water supply and sanitation project for Mufindi District Council.",
    image: songea2,
    images: [songea2, songea3, civilImage],
  },
  {
    slug: "tanzam-highway-pipe-works",
    name: "Tanzam Highway Pipe Works",
    status: "2017",
    role: "Sub-Contractor",
    client: "Mufindi District Council",
    value: "Tshs 61,042,272",
    location: "Kinegembasi, Maguvani, Mbalamaziwa, Nyanyembe, Irimba and Idetero",
    category: "Civil-Water Project",
    description:
      "Supply and installation of pipes and fittings along the Tanzam Highway serving Kinegembasi, Maguvani, Mbalamaziwa, Nyanyembe, Irimba and Idetero villages.",
    image: civilImage,
    images: [civilImage, songea1, songea3],
  },
  {
    slug: "kibaha-road-culvert-maintenance",
    name: "Kibaha Road & Culvert Maintenance",
    status: "2018",
    role: "Main Contractor",
    client: "Kibaha Town Council",
    value: "Tshs 182,863,892",
    location: "Kibaha Town Council",
    category: "Civil Works",
    description:
      "Periodic maintenance, spot improvement, routine maintenance and culvert installation for Misugusugu-Zogowale, Visiga Mbwawa, Visiga Saini and Visigakati Zahanati roads.",
    image: roadImage,
    images: [roadImage, moro2, tazara3],
  },
  {
    slug: "visiga-zegereni-kibaha-maintenance",
    name: "Visiga-Zegereni Kibaha Maintenance",
    status: "2017",
    role: "Main Contractor",
    client: "Kibaha Town Council",
    value: "Tshs 187,720,180",
    location: "Kibaha Town Council",
    category: "Civil Works",
    description:
      "Periodic maintenance, spot improvement, routine maintenance and culvert installation along Visiga Zegereni, Misugusugu-Zogowale, Visiga Kati Zahanati and Industrial Area.",
    image: roadImage,
    images: [roadImage, tazara1, moro1],
  },
  {
    slug: "majohe-kigogo-fresh-box-culvert",
    name: "Majohe-Kigogo Fresh Box Culvert",
    status: "2017",
    role: "Main Contractor",
    client: "Ilala Municipal Council",
    value: "Tshs 196,457,180",
    location: "Ilala Municipality",
    category: "Civil Works",
    description:
      "Construction of a three duct box culvert along Majohe-Kigogo Fresh Road in Ilala Municipality.",
    image: moro3,
    images: [moro3, roadImage, tazara2],
  },
  {
    slug: "kimanga-tasaf-box-culvert",
    name: "Kimanga Tasaf Box Culvert",
    status: "2018-2019",
    role: "Main Contractor",
    client: "TARURA Ilala Municipal",
    value: "Tshs 321,960,000",
    location: "Ilala Municipality",
    category: "Civil Works",
    description:
      "Periodic maintenance and construction of two cells box culvert along the Kimanga Tasaf 2.0km road in Ilala Municipality.",
    image: tazara2,
    images: [tazara2, tazara3, roadImage],
  },
  {
    slug: "mafia-district-road-maintenance",
    name: "Mafia District Road Maintenance",
    status: "2016",
    role: "Main Contractor",
    client: "Mafia District Council",
    value: "Tshs 57,472,000",
    location: "Mafia District",
    category: "Civil Works",
    description:
      "Routine maintenance improvement and periodic maintenance along Ndagoni-Kitomondo, Dongo-Marimbani and Dongo-Kitomondo roads.",
    image: roadImage,
    images: [roadImage, tazara1, moro1],
  },
  {
    slug: "bonyokwa-kwa-pengo-emergency-works",
    name: "Bonyokwa kwa Pengo Emergency Works",
    status: "2017",
    role: "Main Contractor",
    client: "TARURA Ilala",
    value: "Tshs 106,884,400",
    location: "Bonyokwa kwa Pengo",
    category: "Civil Works",
    description:
      "Emergency works at Bonyokwa kwa Pengo for TARURA Ilala.",
    image: tazara3,
    images: [tazara3, roadImage, moro2],
  },
  {
    slug: "picha-ya-ndege-filbert-bay-maintenance",
    name: "Picha ya Ndege-Filbert Bay Maintenance",
    status: "2017",
    role: "Main Contractor",
    client: "Kibaha Town Council",
    value: "Tshs 50,335,260",
    location: "Kibaha Town Council",
    category: "Civil Works",
    description:
      "Municipal maintenance works along Picha ya Ndege-Filbert Bay Road for Kibaha Town Council.",
    image: moro2,
    images: [moro2, roadImage, moro3],
  },
];

export function getProjectBySlug(slug) {
  return projects.find((project) => project.slug === slug);
}

export default function ProjectsContent() {
  const appContext = useContext(AppContext);

  return (
    <>
      <PageHero
        eyebrow="Projects"
        title="Project experience across civil, water, and building works."
        text="SNJ Tanzania Limited's company profile records road maintenance, water infrastructure, culvert construction, residential buildings, public office blocks, and institutional building projects."
        image={civilImage}
      />

      <section className="tgm-section tgm-projects-page">
        <div className="container">
          <MotionGroup className="tgm-section-head" stagger={0.08}>
            <div>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                Execution Experience
              </MotionReveal>
              <MotionText
                as="h2"
                text="Work highlights from the company profile."
              />
            </div>
            <MotionReveal as="p" variant="soft" delay={0.12}>
              These examples show the range of scopes SNJ Tanzania Limited has
              handled as main contractor, sub-contractor, and project delivery
              partner across Tanzania.
            </MotionReveal>
          </MotionGroup>

          <MotionGroup
            className="tgm-home-project-grid tgm-project-page-grid"
            stagger={0.06}
            amount={0.06}
          >
            {projects.map((project, index) => (
              <MotionItem
                as="article"
                variant="card"
                className="tgm-home-project-card tgm-project-page-card"
                key={project.name}
                role="button"
                tabIndex="0"
                onClick={() =>
                  appContext.navTo({
                    item: "projects",
                    subItem: project.slug,
                  })
                }
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    appContext.navTo({
                      item: "projects",
                      subItem: project.slug,
                    });
                  }
                }}
                whileHover={{ y: -8 }}
                whileTap={{ scale: 0.985 }}
              >
                <div className="tgm-home-project-image">
                  <img src={project.image} alt={project.name} />
                </div>
                <h3>{project.name}</h3>
                <p>{project.description}</p>
                <span className="tgm-home-project-link">
                  View Project <MdArrowOutward />
                </span>
              </MotionItem>
            ))}
          </MotionGroup>
        </div>
      </section>

      <CallToAction />
    </>
  );
}
